import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AgentAssistantApiClient } from './api/agent-assistant.api-client';

@Injectable({ providedIn: 'root' })
export class AgentAssistantRonaService {
  public constructor(private readonly agentAssistantApiClient: AgentAssistantApiClient) {}

  public stopRona(userId: string): Observable<void> {
    return this.agentAssistantApiClient.stopRona(userId);
  }
}
